import { ReactComponent as BalerIcon } from '../../assets/icons/baler.svg?icon';
import { ReactComponent as CartIcon } from '../../assets/icons/cart.svg?icon';
import { ReactComponent as DrumIcon } from '../../assets/icons/drum.svg?icon';
import { ReactComponent as FrontLoadContainerIcon } from '../../assets/icons/front-load-container.svg?icon';
import { ReactComponent as HandPickupIcon } from '../../assets/icons/hand-pickup.svg?icon';
import { ReactComponent as OtherCompactorIcon } from '../../assets/icons/other-compactor.svg?icon';
import { ReactComponent as OtherContainerIcon } from '../../assets/icons/other-container.svg?icon';
import { ReactComponent as RearLoadContainerIcon } from '../../assets/icons/rear-load-container.svg?icon';
import { ReactComponent as RollOffCompactorIcon } from '../../assets/icons/roll-off-compactor.svg?icon';
import { ReactComponent as RollOffOpenTopIcon } from '../../assets/icons/roll-off-open-top.svg?icon';
import { ReactComponent as ToterIcon } from '../../assets/icons/toter.svg?icon';
import { addStyles } from '../../utils/helpers';

export interface ServiceIconProps {
  containerType?: keyof typeof options.containers;
  streamType?: keyof typeof options.streams;
  className?: string;
}

const options = {
  base: 'icon rounded-lg bg-gray-50 relative size-16 sm:w-24 sm:h-24 z-0',
  iconBase: 'fill-gray-700 absolute inset-0 m-auto size-8 sm:w-16 sm:h-16',
  iconwithBorder: '-left-2',
  streams: {
    'Trash (MSW) / Landfill': 'border-l-8 border-gray-800',
    'Single-stream recycling': ' border-l-8 border-midday',
    'Cardboard recycling': 'border-l-8 border-poppy',
    'Comingled recycling': 'border-l-8 border-recycling',
    'Paper recycling': 'border-l-8 border-sunflower',
    'Compost organics': 'border-l-8 border-chartreuse',
    'Compost greens': 'border-l-8 border-cactus',
    'Other stream': 'border-l-8 border-gray-500',
    'Electronic recycling': 'border-l-8 border-electric-seaglass',
  },
  containers: {
    'baler': BalerIcon,
    'cart': CartIcon,
    'drum': DrumIcon,
    'toter': ToterIcon,
    'rear-load container': RearLoadContainerIcon,
    'other compactor': OtherCompactorIcon,
    'hand pickup': HandPickupIcon,
    'roll-off compactor': RollOffCompactorIcon,
    'other container': OtherContainerIcon,
    'front-load container': FrontLoadContainerIcon,
    'roll-off open-top container': RollOffOpenTopIcon,
  },
};

export function ServiceIcon({ containerType = 'other container', ...props }: ServiceIconProps) {
  const { streamType, className } = props;

  const ContainerIcon =
    containerType && Object.keys(options.containers).includes(containerType)
      ? options.containers[containerType]
      : OtherContainerIcon;

  const hasStream = streamType && Object.keys(options.streams).includes(streamType);

  return (
    <div
      role="presentation"
      className={addStyles([options.base, hasStream ? options.streams[streamType] : '', className])}
    >
      <ContainerIcon className={addStyles([options.iconBase, hasStream ? options.iconwithBorder : ''])} />
    </div>
  );
}

export default ServiceIcon;
